/**
 * Phase 24 — Influencer Army
 * Tab navigation, counter animations, form handling, KPI counters
 */

(function () {
  'use strict';

  /* ── TAB NAVIGATION ── */
  function initTabs() {
    const tabs = document.querySelectorAll('.ia-tab');
    const panels = document.querySelectorAll('.ia-panel');
    if (!tabs.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.panel;
        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));
        tab.classList.add('active');
        const panel = document.querySelector(`[data-panel-id="${target}"]`);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ── COUNTER ANIMATION ── */
  function animateCounters() {
    const counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || entry.target.dataset.animated) return;
        entry.target.dataset.animated = 'true';

        const el = entry.target;
        const target = parseFloat(el.dataset.count);
        const prefix = el.dataset.prefix || '';
        const suffix = el.dataset.suffix || '';
        const isDecimal = target % 1 !== 0;
        const duration = 2000;
        const startTime = performance.now();

        function update(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = eased * target;

          if (isDecimal) {
            el.textContent = prefix + current.toFixed(1) + suffix;
          } else if (target >= 1000) {
            el.textContent = prefix + Math.floor(current).toLocaleString('en-IN') + suffix;
          } else {
            el.textContent = prefix + Math.floor(current) + suffix;
          }

          if (progress < 1) {
            requestAnimationFrame(update);
          } else {
            if (isDecimal) {
              el.textContent = prefix + target.toFixed(1) + suffix;
            } else if (target >= 1000) {
              el.textContent = prefix + target.toLocaleString('en-IN') + '+';
            } else {
              el.textContent = prefix + target + suffix;
            }
          }
        }

        requestAnimationFrame(update);
      });
    }, { threshold: 0.3 });

    counters.forEach(c => observer.observe(c));
  }

  /* ── APPLICATION FORM ── */
  function initForm() {
    const form = document.getElementById('influencer-application');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      const successEl = document.getElementById('iaFormSuccess');
      if (successEl) {
        // Let Shopify handle the submission, show success on page reload
        // Check if form was submitted via URL params
      }
    });

    // Check for successful submission (Shopify redirects with anchor)
    if (window.location.hash === '#contact_form=success' || 
        document.querySelector('.ia-form .form--success')) {
      const formEl = document.getElementById('iaApplicationForm');
      const successEl = document.getElementById('iaFormSuccess');
      if (formEl && successEl) {
        formEl.querySelector('form')?.classList.add('hidden');
        formEl.querySelector('.ia-form__title')?.classList.add('hidden');
        successEl.classList.add('active');
      }
    }
  }

  /* ── HOVER EFFECTS ── */
  function initHoverEffects() {
    const cards = document.querySelectorAll('.ia-tier, .ia-playbook, .ia-spot-card, .ia-res-card');
    cards.forEach(card => {
      card.addEventListener('mouseenter', function () {
        this.style.willChange = 'transform';
      });
      card.addEventListener('mouseleave', function () {
        this.style.willChange = 'auto';
      });
    });
  }

  /* ── LEADERBOARD ANIMATION ── */
  function initLeaderboard() {
    const items = document.querySelectorAll('.ia-lb-item');
    if (!items.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateX(0)';
          }, index * 100);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    items.forEach(item => {
      item.style.opacity = '0';
      item.style.transform = 'translateX(-20px)';
      item.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(item);
    });
  }

  /* ── INIT ── */
  function init() {
    initTabs();
    animateCounters();
    initForm();
    initHoverEffects();
    initLeaderboard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
